import React from 'react';
import './ActivityTierBadge.css';

const ActivityTierBadge = ({ tier, size = 'md' }) => {
  const tierClass = tier.toLowerCase().replace(' ', '-');
  
  return (
    <span className={`activity-tier-badge tier-${tierClass} size-${size}`}>
      {tier}
    </span>
  );
};

export default ActivityTierBadge;